(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["holding-about-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      const root = document.querySelector('.ghw-page');
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const reveals = root.querySelectorAll('.ghw-reveal');
      if (reduced || !('IntersectionObserver' in window)) {
        reveals.forEach((item) => item.classList.add('is-visible'));
      } else {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        reveals.forEach((item) => observer.observe(item));
      }
      const timeline = root.querySelector('[data-ghw-timeline]');
      if (timeline) {
        let frame = null;
        const update = () => {
          frame = null;
          const rect = timeline.getBoundingClientRect();
          const start = window.innerHeight * 0.72;
          const distance = rect.height + start - window.innerHeight * 0.18;
          const progress = Math.min(1, Math.max(0, (start - rect.top) / distance));
          timeline.style.setProperty('--ghw-progress', `${progress * 100}%`);
        };
        const queue = () => {
          if (frame === null) frame = window.requestAnimationFrame(update);
        };
        update();
        window.addEventListener('scroll', queue, { passive: true });
        window.addEventListener('resize', queue, { passive: true });
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holding-awards-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-gh-awards]');

    roots.forEach((root) => {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const revealItems = root.querySelectorAll('[data-reveal]');
      const timeline = root.querySelector('[data-gh-timeline]');

      if (!reducedMotion && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

        revealItems.forEach((item) => observer.observe(item));
      } else {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      }

      if (!timeline) return;

      let frame;
      const updateProgress = () => {
        frame = null;
        const rect = timeline.getBoundingClientRect();
        const viewportPoint = window.innerHeight * 0.62;
        const progress = Math.min(1, Math.max(0, (viewportPoint - rect.top) / rect.height));
        timeline.style.setProperty('--gha-progress', `${progress * 100}%`);
      };

      const requestUpdate = () => {
        if (!frame) frame = window.requestAnimationFrame(updateProgress);
      };

      updateProgress();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
